import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DocumentDto, DocumentUrlDto } from '@app/data/dtos/ptrab/documents/document.dto';
import {
  mapDocumentsData,
  mapDocumentsDataOnBoarding,
  mapUrlDocument
} from '@app/data/mappers/ptrab/documents/documents.mappers';
import { DocumentsRepository } from '@app/domain/repositories/ptrab/documents/documents.repository.contract';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { DocumentUrl } from '@app/entities/models/ptrab/documents/document-url.model';
import { Document } from '@app/entities/models/ptrab/documents/document.model';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class DocumentsRepositoryImpl extends MRepository implements DocumentsRepository {
  constructor() {
    super(`${ENV.API_URL_PTRAB}`);
  }

  documentsUrl = '/ptrab/documents';

  getDocuments(): Observable<Document[]> {
    return this.get<IDataResponse<DocumentDto[]>>(this.documentsUrl, {
      context: new HttpContext().set(SECTION_KEY, 'pending-documents')
    }).pipe(map(mapDocumentsData));
  }

  getDocumentUrlById(documentId: string): Observable<DocumentUrl> {
    return this.get<DocumentUrlDto>(`${this.documentsUrl}/${documentId}/url`).pipe(map(mapUrlDocument));
  }

  getOnBoardingDocument(): Observable<Document[]> {
    return this.get<IDataResponse<DocumentDto[]>>(`${this.documentsUrl}/onboarding`, {
      context: new HttpContext().set(SECTION_KEY, 'onboarding-documents')
    }).pipe(map(mapDocumentsDataOnBoarding));
  }

  getOnBoardingDocumentUrlById(documentId: string): Observable<DocumentUrl> {
    return this.get<DocumentUrlDto>(`${this.documentsUrl}/onboarding/${documentId}/url`, {
      context: new HttpContext().set(SECTION_KEY, 'onboarding-document-url')
    }).pipe(map(mapUrlDocument));
  }
}
